var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.rowData.status == 'overdue'
      ? 'badge-danger'
      : _vm.rowData.status == 'paid'
      ? 'badge-success'
      : 'badge-warning'},[_vm._v(" "+_vm._s(_vm.rowData.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }